import { get } from 'lodash';

export const WorkoutPlayerInstructions = {
  bindings: {
    step: '<',
    show: '<',
    onClose: '&',
  },

  template: `
    <div class="workout-player-detail pb-4"
      ng-show="$ctrl.show" id="exercise-details">
      <div class="close-btn-container">
        <div class="close-btn">
          <button
            type="button"
            ng-click="$ctrl.onClose()"
            class="btn-link">
            Close Instructions
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
      <div class="exercise-info-container pt-3"
        ng-bind-html="$ctrl.step.exercise.contentHtml">
      </div>
      <div class="mish-tips-container"
        ng-show="$ctrl.step.exercise.mishTipsHtml">
        <h3>Voome Tips</h3>
        <div ng-bind-html="$ctrl.step.exercise.mishTipsHtml"></div>
      </div>
    </div>`,

  controller($element) {
    'ngInject';

    return {
      $onChanges(changes) {
        if (get(changes, 'show.currentValue') === true) {
          $('html, body').animate({
            scrollTop: $element.offset().top,
          });
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerInstructions.js